(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Add class to cart icon when items are added
  document.addEventListener('DOMContentLoaded', function() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    const cartCountBubble = cartIcon?.querySelector('.cart-count-bubble');
    
    if (cartCountBubble && !cartCountBubble.querySelector(':empty')) {
      cartIcon.classList.add('cart-has-items');
    }
    
    // Watch for cart updates
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const cartCountBubble = cartIcon?.querySelector('.cart-count-bubble');
          if (cartCountBubble && !cartCountBubble.querySelector(':empty')) {
            cartIcon.classList.add('cart-has-items');
          } else {
            cartIcon.classList.remove('cart-has-items');
          }
        }
      });
    });
    
    if (cartIcon) {
      observer.observe(cartIcon, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // When cart is updated outside theme form (e.g. Opus, fallback), update price and count bubble in header cart icon
    function refreshHeaderCartIcon() {
      if (!cartIcon || !window.routes) return;
      var priceEl = cartIcon.querySelector('.cart-total-amount');
      if (!priceEl) return;
      var url = window.routes.cart_url + '?section_id=cart-icon-bubble';
      var doFetch = function() {
        fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-cart-icon-bubble');
          var newPriceEl = section ? section.querySelector('.cart-total-amount') : null;
          var newBubbleEl = section ? section.querySelector('.cart-count-bubble') : null;
          var currentBubble = cartIcon.querySelector('.cart-count-bubble');
          if (newPriceEl) priceEl.innerHTML = newPriceEl.innerHTML;
          if (newBubbleEl) {
            if (currentBubble) {
              currentBubble.innerHTML = newBubbleEl.innerHTML;
            } else {
              cartIcon.insertBefore(newBubbleEl.cloneNode(true), priceEl);
            }
            cartIcon.classList.add('cart-has-items');
          } else {
            if (currentBubble) currentBubble.remove();
            cartIcon.classList.remove('cart-has-items');
          }
        })
        .catch(function() {});
      };
      setTimeout(doFetch, 150);
    }
    document.addEventListener('cart:updated', refreshHeaderCartIcon);
  });

  // Mobile sticky header with 80px scroll trigger
  document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const sectionHeader = document.querySelector('.section-header');
    const body = document.body;
    
    if (headerWrapper || sectionHeader) {
      let ticking = false;
      
      function updateHeaderOnScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 80) {
          // Add scrolled class to make header sticky
          if (headerWrapper) headerWrapper.classList.add('scrolled');
          if (sectionHeader) sectionHeader.classList.add('scrolled');
          body.classList.add('header-scrolled');
        } else {
          // Remove scrolled class to make header normal
          if (headerWrapper) headerWrapper.classList.remove('scrolled');
          if (sectionHeader) sectionHeader.classList.remove('scrolled');
          body.classList.remove('header-scrolled');
        }
        
        ticking = false;
      }
      
      function requestTick() {
        if (!ticking) {
          requestAnimationFrame(updateHeaderOnScroll);
          ticking = true;
        }
      }
      
      // Only apply on mobile devices (max-width: 768px)
      function handleScroll() {
        if (window.innerWidth <= 768) {
          requestTick();
        }
      }
      
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      
      // Initial check
      handleScroll();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
